// extracted by mini-css-extract-plugin
export default {"wrapper":"CategoryGroup_wrapper__yiuxd","category_group":"CategoryGroup_category_group__7Joid","select_box":"CategoryGroup_select_box__9+F7S","arrow":"CategoryGroup_arrow__8Zo89"};